function Footer() {
  return (
    <div className="footer">
      <p>Copyright © Tacettin Batuhan Bostanci</p>
    </div>
  );
}

export default Footer;
